"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingCalendarPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const calendar_1 = require("../../calendar/calendar");
const auth_1 = require("../../utils/auth");
const helpers_1 = require("../../utils/helpers");
const form_for_1 = require("../../widgets/form_for");
exports.BookingCalendarPage = {
    view() {
        app_1.App.exitConfirmation = calendar_1.Calendar.editMode ?
            "Vous etes en mode edition. Quitter cette page risque de ne pas appliquer les bookings dans la zone tampon. Etes-vous sûr?" : undefined;
        return (0, mithril_1.default)("div", { class: "content mcal-page" }, (0, mithril_1.default)("div", { class: "mcal-title" }, (0, form_for_1.columns)((0, mithril_1.default)("h1.is-hidden-touch", { style: "padding-left: 0.5em;" }, "Calendrier des réservations", (0, mithril_1.default)("br"), (0, mithril_1.default)("small", calendar_1.Calendar.dayModel().day.format("dddd DD MMMM YYYY"))), (0, helpers_1.ifTrue)(auth_1.Auth.isAdmin() && !(0, helpers_1.isMobile)(), (0, mithril_1.default)("button", {
            style: "margin-right: 1em;",
            class: "button is-warning is-pulled-right",
            disabled: !calendar_1.Calendar.allowEditMode(),
            onclick: () => { calendar_1.Calendar.toggleEditionMode(); }
        }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Mode edition"))))), (0, mithril_1.default)("div", { class: "mcal-content" }, (0, mithril_1.default)(calendar_1.Calendar)));
    }
};
